function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInput = function SvgInput(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 19H4c-.9 0-1.4 0-1.7-.3S2 17.9 2 17V7c0-.9 0-1.4.3-1.7S3.1 5 4 5h16c.9 0 1.4 0 1.7.3s.3.8.3 1.7v10c0 .9 0 1.4-.3 1.7s-.8.3-1.7.3H9",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8v8",
    style: {
      fill: "none",
      stroke: "#333",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }));
};
export default SvgInput;